import Lenis from 'lenis'

const windowLenis = {
	init() {
		if (window.isMobile) {
			return
		}

		// Initialize a new Lenis instance for smooth scrolling
		const lenis = new Lenis()

		// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
		lenis.on('scroll', window.ScrollTrigger.update)

		// Add Lenis's requestAnimationFrame (raf) method to GSAP's ticker
		// This ensures Lenis's smooth scroll animation updates on each GSAP tick
		window.gsap.ticker.add((time) => {
			lenis.raf(time * 1000) // Convert time from seconds to milliseconds
		})

		// Disable lag smoothing in GSAP to prevent any delay in scroll animations
		window.gsap.ticker.lagSmoothing(0)
		window.lenis = lenis
	},
}

export default windowLenis
